import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "funnelTab", "externalTab",
        "funnelSection", "externalSection",
        "funnelInput", "externalInput"
    ]

    connect() {
        this.updateState()
    }

    selectFunnel(event) {
        if (event) event.preventDefault()
        this.setMode('funnel')
    }

    selectExternal(event) {
        if (event) event.preventDefault()
        this.setMode('external')
    }

    setMode(mode) {
        if (mode === 'funnel') {
            // Updates Tabs
            this.funnelTabTarget.classList.add('bg-white', 'text-indigo-600', 'shadow-sm')
            this.funnelTabTarget.classList.remove('text-gray-500', 'hover:text-gray-900')

            this.externalTabTarget.classList.remove('bg-white', 'text-indigo-600', 'shadow-sm')
            this.externalTabTarget.classList.add('text-gray-500', 'hover:text-gray-900')

            // Update Sections
            this.funnelSectionTarget.classList.remove('hidden')
            this.externalSectionTarget.classList.add('hidden')

            // Enable/Disable Inputs
            this.funnelInputTargets.forEach(input => input.disabled = false)
            this.externalInputTarget.disabled = true

        } else {
            // Update Tabs
            this.externalTabTarget.classList.add('bg-white', 'text-indigo-600', 'shadow-sm')
            this.externalTabTarget.classList.remove('text-gray-500', 'hover:text-gray-900')

            this.funnelTabTarget.classList.remove('bg-white', 'text-indigo-600', 'shadow-sm')
            this.funnelTabTarget.classList.add('text-gray-500', 'hover:text-gray-900')

            // Update Sections
            this.externalSectionTarget.classList.remove('hidden')
            this.funnelSectionTarget.classList.add('hidden')

            // Enable/Disable Inputs
            this.funnelInputTargets.forEach(input => input.disabled = true)
            this.externalInputTarget.disabled = false
        }
    }

    updateState() {
        const externalUrl = this.externalInputTarget.value
        if (externalUrl && externalUrl.trim() !== '') {
            this.setMode('external')
        } else {
            this.setMode('funnel')
        }
    }
}
